const resolveFilesNames = (urls) => {
  return urls.map((url, index) => {
    let name = url.split('/').slice(-1)[0];
    name = name.replace(/___[^.]+/, '');
    return { name, url, id: String(index) };
  });
};

export default resolveFilesNames;
